import React from "react";
import { Button } from "../ui/Button";
import { VideoPlayer } from "../ui/VideoPlayer";
import type { HeroSection as HeroSectionType } from "../../types/content.types";

interface HeroSectionProps {
  content: HeroSectionType;
  onCtaClick: () => void;
}

export function HeroSection({ content, onCtaClick }: HeroSectionProps) {
  return (
    <section className="bg-black pt-16 pb-20 px-4">
      <div className="w-full lg:w-[92%] mx-auto px-4">
        <div className="flex flex-col items-center text-center gap-8">
          {/* Main Heading */}
          <h1 className="text-[#fbbf24] leading-tight max-w-4xl text-3xl sm:text-5xl lg:text-6xl font-bold">
            {content.heading}
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-white leading-relaxed max-w-3xl">
            {content.subheading}
          </p>

          {/* Video */}
          <div className="w-full flex justify-center">
            <VideoPlayer
              key={content.youtubeId}
              youtubeId={content.youtubeId}
              posterUrl={content.videoPoster}
              title={content.heading}
            />
          </div>

          {/* CTA Button */}
          <div className="flex justify-center mt-6">
            <Button variant="primary" size="lg" onClick={onCtaClick}>
              {content.ctaText}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
